import { FormattedMessage } from "react-intl"

// Components
import {
  CustomButton,
  Modal
} from "../../../common"

// Constants
import { GA_EVENTS } from "../../../../constants/analytics"

const CVLimitFreemiumModal = ({
  open = false,
  setOpen = () => {},
  onUpgrade = () => {},
  onCancel = () => {},
  cvLimit
}) => (
  <Modal open={open} setOpen={setOpen} className="limit-dialog">
    <div className="limit-dialog__container">
      <h2 className="text-2xl font-bold">
        <FormattedMessage id="common.cvLimitReached" />
      </h2>
      <p>
        <FormattedMessage
          id="message.cvLimitReachedDescription"
          values={{ limit: cvLimit }}
        />
      </p>
      <div className="flex gap-2 limit-dialog__buttons">
        <CustomButton
          className="btn btn--small primary mr-2"
          onClick={onUpgrade}
          trackingEvent={GA_EVENTS.SELECT_CV.UPGRADE_TO_PREMIUM}
        >
          <FormattedMessage id="common.upgradeToPremium" />
        </CustomButton>
        <CustomButton
          className="btn btn--small"
          onClick={onCancel}
          trackingEvent={GA_EVENTS.SELECT_CV.MODAL_CANCEL}
        >
          <FormattedMessage id="common.cancel" />
        </CustomButton>
      </div>
    </div>
  </Modal>
);

export default CVLimitFreemiumModal;
